/**
 * Creates the common CRUD handler used by synchronized entity stores.
 *
 * The table name is supplied by the trusted entity registry rather than by
 * protocol input, so this generic handler does not expose arbitrary Dexie
 * tables through an external entity_type value.
 *
 * @param {Object} database - Open Dexie database instance.
 * @param {string} tableName - Allowlisted Dexie table name.
 * @returns {Object} Generic entity persistence handler.
 */
export const createEntityStore = (database, tableName) => {
  const table = database.table(tableName);

  return {
    get: (id) => table.get(id).then((entity) => entity || null),

    list: () => table.toArray(),

    listByIds: (ids) =>
      table.bulkGet(ids).then((entities) => entities.filter(Boolean)),

    upsert: (entity) => table.put(entity).then(() => undefined),

    delete: (id) => table.delete(id)
  };
};
